// extracted by mini-css-extract-plugin
module.exports = {"fadeLeftSection":"FadeLeft-module--fade-left-section--2p7sX","isVisible":"FadeLeft-module--is-visible--2Ba31"};